<roots-page-header
  [toolTip]="_config.toolTip"
  [title]="_config.title"
  [loading]="_config.loading"
>
</roots-page-header>
<hr>
<div class="data-wrapper gray">
  <mat-card class="col-12" style="float: left;" *ngIf="firmware">
    <h3 class="text label-header-text">Details</h3>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput placeholder="Name" [(ngModel)]="firmware.name" required />
        </mat-form-field>
        
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input
            matInput
            placeholder="Description"
            [(ngModel)]="firmware.description"
            required
          />
        </mat-form-field>
        
        <mat-form-field>
          <mat-label>Code</mat-label>
          <input matInput placeholder="Code" [(ngModel)]="firmware.code" />
        </mat-form-field>
        
        <mat-form-field>
          <mat-label>Firmware Version</mat-label>
          <input
            matInput
            placeholder="Firmware Version"
            [(ngModel)]="firmware.firmwareVersion"
            required
          />
        </mat-form-field>
        
        <mat-form-field>
          <mat-label>Begin</mat-label>
          <input
            matInput
            disabled
            placeholder="Beginning"
            [(ngModel)]="firmware.whenBegin"
            required
          />
        </mat-form-field>
        
        <!-- <mat-form-field>
          <mat-label>Scouts Assigned to this Firmware</mat-label>
          <mat-select matInput placeholder="Current Scouts (Assets)" required [(ngModel)]="assetModels[0].id" 
                  name="assetModel">
                  <mat-option *ngFor="let model of assetModels" [value]="model.id">
                      {{ model.basicName }}
                  </mat-option>
              </mat-select>
        </mat-form-field> -->
        
        <mat-form-field>
          <mat-label>End</mat-label>
          <input
            matInput
            disabled
            placeholder="Ending"
            [(ngModel)]="firmware.whenEnd"
            required
          />
        </mat-form-field>
        
        <button
          mat-raised-button
          type="submit"
          style="max-width: fit-content"
          color="warn"
          (click)="onNoClick()"
        >
          Cancel
        </button>
        <button
          mat-raised-button
          type="submit"
          style="max-width: fit-content"
          color="primary"
          (click)="onUpdate(firmware)"
        >
          Update
        </button>
    </mat-card>
    <mat-label>Asset Models</mat-label>
    <roots-table
    class="col-12" style="float: left;"
    [tableColumns]="_config.displayedColumns"
    [dataSource]="_config.dataSource"
    [filter]="_config.message"
    [csv]="_config.title"
    [clickingEnabled]="true">
    </roots-table>
</div>
